import React from 'react';
import { Clock, BookOpen, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const CourseCard = ({ course, type = 'live' }) => {
  const handleEnroll = () => {
    window.open(course.exlyLink, '_blank');
  };

  return (
    <div 
      className="group bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl overflow-hidden hover:border-red-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-red-500/10 hover:-translate-y-1"
      data-testid={`course-card-${course.id}`}
    >
      {/* Course Image */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={course.image}
          alt={course.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>

        {/* Category Badge */}
        <div className="absolute top-4 left-4">
          <span className="bg-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
            {course.category}
          </span>
        </div>
      </div>

      {/* Course Content */}
      <div className="p-6 space-y-4">
        <h3 className="text-xl font-bold text-white line-clamp-2 min-h-[56px] group-hover:text-red-500 transition-colors break-words">
          {course.title}
        </h3>

        {/* Course Info */}
        <div className="flex flex-wrap items-center gap-4 text-sm text-gray-400">
          {type === 'live' || type === 'Advance-Training' ? (
            <>
              <div className="flex items-center gap-1">
                <Clock className="w-4 h-4 text-red-500 flex-shrink-0" />
                <span className="break-words">{course.duration}</span>
              </div>
              <div className="flex items-center gap-1">
                <BookOpen className="w-4 h-4 text-red-500 flex-shrink-0" />
                <span className="break-words">{course.trainingType}</span>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center gap-1">
                <BookOpen className="w-4 h-4 text-red-500 flex-shrink-0" />
                <span className="break-words">{course.lectures}</span>
              </div>
            </>
          )}
        </div>

        {/* Features or Description */}
        {course.features ? (
          <ul className="space-y-2">
            {course.features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-400">
                <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                <span className="break-words">{feature}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-400 line-clamp-2 break-words">{course.description}</p>
        )}

        {/* CTA Button */}
        <Button
          className="w-full bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white transition-all duration-300 group-hover:shadow-lg group-hover:shadow-red-500/30"
          onClick={handleEnroll}
          data-testid={`enroll-button-${course.id}`}
        >
          Enroll Now
          <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </Button>
      </div>
    </div>
  );
};

export default CourseCard;
